import Hero from "../components/Hero";
import TrustBar from "../components/TrustBar";
import Features from "../components/Features";
import FinOpsSection from "../components/FinOpsSection";
import HowItWorks from "../components/HowItWorks";
import CaseStudy from "../components/CaseStudy";
import AboutCloudlaya from "../components/AboutCloudlaya";
import Pricing from "../components/Pricing";
import Faq from "../components/Faq";
import Contact from "../components/Contact";
import FinalCta from "../components/FinalCta";

export default function HomePage() {
  return (
    <>
      <Hero />
      <TrustBar />
      <Features />
      <FinOpsSection />
      <HowItWorks />
      <CaseStudy />
      <AboutCloudlaya />
      <Pricing />
      <Faq />
      <Contact />
      <FinalCta />
    </>
  );
}
